import { useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { api, formatApiError } from "@/lib/api";

const EMPTY = { name: "", email: "", phone: "", subject: "", message: "" };

export default function EnquiryForm() {
  const [form, setForm] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/enquiries", { ...form, subject: form.subject || "General enquiry" });
      toast.success("Thanks — your enquiry has been sent. We'll be in touch shortly.");
      setForm(EMPTY);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="panel space-y-5 p-6 sm:p-8" data-testid="enquiry-form">
      <div className="grid gap-5 sm:grid-cols-2">
        <div className="space-y-2">
          <Label htmlFor="enq-name">Full name</Label>
          <Input id="enq-name" required value={form.name} onChange={set("name")} className="field" data-testid="enquiry-name-input" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="enq-email">Email</Label>
          <Input id="enq-email" type="email" required value={form.email} onChange={set("email")} className="field" data-testid="enquiry-email-input" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="enq-phone">Phone (optional)</Label>
          <Input id="enq-phone" value={form.phone} onChange={set("phone")} className="field" data-testid="enquiry-phone-input" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="enq-subject">Subject</Label>
          <Input id="enq-subject" placeholder="e.g. Property investment" value={form.subject} onChange={set("subject")} className="field" data-testid="enquiry-subject-input" />
        </div>
      </div>
      <div className="space-y-2">
        <Label htmlFor="enq-message">Message</Label>
        <Textarea id="enq-message" required minLength={5} rows={5} value={form.message} onChange={set("message")} className="rounded-xl border-line bg-surface" data-testid="enquiry-message-input" />
      </div>
      <button type="submit" disabled={busy} className="btn-primary w-full sm:w-auto" data-testid="enquiry-submit-button">
        <Send className="h-4 w-4" /> {busy ? "Sending..." : "Send enquiry"}
      </button>
    </form>
  );
}
